import axios from 'axios';

declare module 'axios' {
  interface AxiosRequestConfig {
    _suppressError?: boolean;
  }
  interface InternalAxiosRequestConfig {
    _suppressError?: boolean;
  }
}
import { jwtDecode } from 'jwt-decode';
import { ITokenPayload } from './types';

export const api = axios.create({
  // @ts-ignore
  baseURL: window._env_.REACT_APP_API_URL_HOST,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getToken = () => {
  return sessionStorage.getItem('token');
};

export const getPermissions = (): string[] | string | null => {
  const token = sessionStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode<ITokenPayload>(window.atob(token));
    return decoded.permissions;
  }
  return null;
};

export const getPlans = (): string[] | string | null => {
  const token = sessionStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode<ITokenPayload>(window.atob(token));
    return decoded.plans;
  }
  return null;
};

export const getUserId = () => {
  const token = sessionStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode(window.atob(token));
    return decoded.sub;
  }
};

export const getLicenseId = () => {
  const token = sessionStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode<ITokenPayload & Record<string, any>>(window.atob(token));
    return (
      decoded.licenseId ||
      decoded.nameId ||
      decoded.nameid ||
      decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] ||
      null
    );
  }
  return null;
};
import { ref, getDownloadURL } from 'firebase/storage';
import { ensureFirebaseAuth, storage } from '../firebase';
import { extractFirebasePath } from '../firebase';
import { getAuth } from 'firebase/auth';


export async function getTemporaryImageUrlFromPublicUrl(
  publicUrl: string
): Promise<string | null> {
  if (!publicUrl) return null;

  try {
    const decoded = decodeURIComponent(publicUrl);
    const match = decoded.match(/\/o\/(.+?)(\?|$)/);

    if (!match || !match[1]) {
      console.warn("Não foi possível extrair o path da imagem:", publicUrl);
      return null;
    }

    const auth = getAuth();
    // Possivel vazamento de memoria aqui, pois o listener não é removido. 
    // Idealmente, deveríamos usar onAuthStateChanged apenas uma vez na inicialização do app 
    // e garantir que o usuário esteja autenticado antes de chamar esta função.
    // Caso der erro em algum lugar descomentar essa linha
    //auth.onAuthStateChanged(() => {});

    const path = match[1];
    const fileRef = ref(storage, path);

    return await getDownloadURL(fileRef);

  } catch (error: any) {
    if (error?.code === 'storage/object-not-found') {
      console.warn(`[Firebase] Imagem não encontrada no repositório: ${publicUrl}. Retornando fallback.`);
      return null;
    }

    console.error("Erro inesperado ao buscar imagem no Firebase:", error);
    return null;
  }
}

export const getUserName = (): string[] | string | null => {
  const token = sessionStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode<ITokenPayload>(window.atob(token));
    return decoded.name;
  }
  return null;
};

export const getEmail = (): string[] | string | null => {
  const token = sessionStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode<ITokenPayload>(window.atob(token));
    return decoded.email;
  }
  return null;
};
